// components/MarkdownPreview.tsx
'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import MarkdownIt from 'markdown-it';
import 'github-markdown-css/github-markdown-light.css';
import './markdown.css';
export interface TocItem {
  id: string;
  text: string;
  level: number;
}
export function getTocItems(content: string): TocItem[] {
  if (!content) return [];
  const headingRegex = /^(#{1,6})\s+(.+)$/gm;
  const toc: TocItem[] = [];
  let match;
  while ((match = headingRegex.exec(content)) !== null) {
    const level = match[1].length;
    const text = match[2].trim();
    const id = text.toLowerCase().replace(/[^a-z0-9\u4e00-\u9fff]+/g, '-').replace(/(^-|-$)/g, '');
    toc.push({
      id,
      text,
      level
    });
  }
  return toc;
}
function generateHeadingId(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9\u4e00-\u9fff]+/g, '-').replace(/(^-|-$)/g, '');
}
const md = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true
});

// Custom renderer for headings with IDs
md.renderer.rules.heading_open = function (tokens, idx) {
  const token = tokens[idx];
  const level = token.markup.length;
  const nextToken = tokens[idx + 1];
  if (nextToken && nextToken.type === 'inline') {
    const headingText = nextToken.content;
    const id = generateHeadingId(headingText);
    return `<h${level} id="${id}">`;
  }
  return `<h${level}>`;
};

// Custom renderer for links with nofollow
md.renderer.rules.link_open = function (tokens, idx, options, env, renderer) {
  const token = tokens[idx];
  const hrefIndex = token.attrIndex('href');
  if (hrefIndex >= 0) {
    const href = token.attrGet('href');
    // Add nofollow to all links
    token.attrSet('rel', 'nofollow');
    // Optionally add target="_blank" for external links
    if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
      token.attrSet('target', '_blank');
    }
  }
  return renderer.renderToken(tokens, idx, options);
};
interface MarkdownPreviewProps {
  content: string;
}
export function MarkdownPreview(t0) {
  const $ = _c(4);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content) {
    t1 = content ? md.render(content) : "";
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const html = t1;
  let t2;
  if ($[2] !== html) {
    t2 = <div className="markdown-body" dangerouslySetInnerHTML={{
      __html: html
    }} />;
    $[2] = html;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}